module.exports = __webpack_public_path__ + "0b0e1b4bccf650e4d1d447fd8cb3f907.pdf";